import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonHeading, CommonDateRange, CommonInput, CommonModal, CustomPagination, CustomSelect, TabWithFillter } from 'components'
import StorageService from "utils/StorageServices/StorageServices";
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import AddEditSupplier from 'modals/AddEditSupplier';
import moment from 'moment';
import { deleteSupplierData, getSupplierListData } from '_services/accountsServices/supplierServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiClock, FiEdit } from "react-icons/fi";
import { FaFilter, FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { getInvoiceBillRaiseListData, getPendingClaimList, getPendingLrList } from '_services/invoiceBillRaiseServices/invoiceBillRaiseServices';
import { utils } from 'helper';
import { UserContext } from 'context';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import Loading from 'pages/Loading';
import useDocumentTitle from 'hooks/useDocumentTitle';
import invoiceTb_icon from '../../../src/assets/img/invoice_icon.svg';
import pendingTb_icon from '../../../src/assets/img/pe_calender.svg';
import overDueTb_icon from '../../../src/assets/img/dueClock_icon.svg';
import cancelTb_icon from '../../../src/assets/img/cancelFile_icon.svg';
import completedTb_icon from '../../../src/assets/img/doubleCheck_icon.svg';
import sparkelIcon from '../../../src/assets/img/sparkel.svg';
import smrtCacl from '../../../src/assets/img/greenSparkel.svg';
import quckpross from '../../../src/assets/img/quick_process.svg';
import detailAnl from '../../../src/assets/img/detail_analysisi.svg';
import { AiOutlineTool } from "react-icons/ai";
import { getConsignorDropdownListData } from '_services/dropdownServices/dropdownService';
import { RxCross2 } from 'react-icons/rx';
import { AddEditLrModal, LrDetailModal } from 'modals';
import './invoicing.css'

const billRaiseInvoiceListTabs = [
  { id: 0, name: "All Invoice", value: "__allInvoice_icon", balance: 0, amount_key: 'Pending', invoice_amount: 10000, src: invoiceTb_icon },
  { id: 1, name: "Pending", value: "__pending_icon", balance: 0, amount_key: 'Total', invoice_amount: 10000, src: pendingTb_icon },
  { id: 3, name: "Completed", value: "__completed_icon", balance: 0, amount_key: 'Today', invoice_amount: 10000, src: completedTb_icon },
  { id: 4, name: "Cancelled", value: "__cancelled_icon", balance: 0, amount_key: 'Today', invoice_amount: 10000, src: cancelTb_icon },
  { id: 5, name: "Overdue", value: "__overdue_icon", balance: 0, amount_key: 'Total', invoice_amount: 10000, src: overDueTb_icon },
]

const Invoicing = () => {
  const navigate = useNavigate()
  const { masterData, setInvoiceBillRaiseData, allMenu, setInvoiceTableToggle } = useContext(UserContext)
  const childsUser = allMenu?.find((i) => i?.label === "Invoicing");

  const [invoiceActiveTab, setInvoiceActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceCounts, setInvoiceCounts] = useState(billRaiseInvoiceListTabs);

  const [pendingLrList, setPendingLrList] = useState([]);
  const [pendingLrCounts, setPendingLrCounts] = useState({});

  const [claimList, setClaimList] = useState([]);
  const [claimCounts, setClaimCounts] = useState({});

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  // lr modal
  const [showAddLR, setShowAddLR] = useState(false)
  const [showLrDetail, setShowLrDetail] = useState(false)

  // filters 

  const [consignorList, setConsignorList] = useState([]);
  const [masterDataLrStatus, setMasterDataLrStatus] = useState([]);
  const [masterDataPodStatus, setMasterDataPodStatus] = useState([]);

  const [pendingFilters, setPendingFilters] = useState({
    search: "",
    consignor_id: "",
    pod_status: 0,
    lr_status: 0,
    start_date: "",
    end_date: "",
  })

  // claim list

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    status: 1,
  });

  useDocumentTitle("Invoice | T360");

  const getDataInvoiceBillRaiseList = async () => {
    try {
      let object = {
        ...filter,
        search: filter.search,
        billraise_status: invoiceActiveTab,
        company_id: StorageService.getCompanyId(),
      }
      delete object.status;

      const res = await getInvoiceBillRaiseListData(object);
      if (res?.responseCode == 200) {
        setLoading(false);
        setInvoiceList(res?.data?.billraise_list);

        const updatedTabs = billRaiseInvoiceListTabs.map((tab) => {
          const backendItem = res?.data?.invoice_status.find((item) => item?.id === tab?.id);
          return backendItem
            ? { ...tab, ...backendItem }
            : tab;
        });
        setInvoiceCounts(updatedTabs);
        setTotalItems(res?.data?.total_record);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  const getDataPendingLrList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        consignor_id: pendingFilters?.consignor_id?.value ? pendingFilters?.consignor_id?.value : '',
        pod_status: pendingFilters?.pod_status?.value ? pendingFilters?.pod_status?.value : 0,
        lr_status: pendingFilters?.lr_status?.value ? pendingFilters?.lr_status?.value : 0,
        start_date: pendingFilters?.start_date,
        end_date: pendingFilters?.end_date,
        search: pendingFilters?.search,
        limit: filter?.limit,
        offset: filter?.offset
      }
      delete object.status;

      const res = await getPendingLrList(object);
      if (res?.responseCode == 200) {
        setLoading(false);
        setPendingLrList(res?.data?.lr_list);
        setPendingLrCounts(res?.data?.lr_freight);
        setTotalItems(res?.data?.total_record);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  const getDataClaimList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        consignor_id: pendingFilters?.consignor_id?.value ? pendingFilters?.consignor_id?.value : '',
        search: pendingFilters?.search,
        limit: filter?.limit,
        offset: filter?.offset,
        search: filter.search,
      }
      delete object.status;

      const res = await getPendingClaimList(object);
      if (res?.responseCode == 200) {
        setLoading(false);
        setClaimList(res?.data?.list);
        setClaimCounts(res?.data?.claim_amount);
        setTotalItems(res?.data?.total_record);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  useEffect(() => {
    setLoading(true);
    if (filter.status === 1) {
      setTotalItems(0);
      getDataInvoiceBillRaiseList();
    }
    if (filter.status === 2) {
      setTotalItems(0);
      getDataPendingLrList();
    }
    if (filter.status === 3) {
      setTotalItems(0);
      getDataClaimList();
    }
    // setInvoiceTableToggle(false);
  }, [filter, invoiceActiveTab, pendingFilters])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteInvoiceBillRaise = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        supplier_id: isDelete?._id,
      }
      const res = await deleteSupplierData(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataInvoiceBillRaiseList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteInvoiceBillRaise,
    isLoadding: loading,
  }
  // invoice list start
  const columns = [
    { header: "", accessor: "serial" },
    { header: "Invoice Number", accessor: "invoice_number" },
    { header: "Type", accessor: "type" },
    { header: "Invoice Date", accessor: "date" },
    { header: "Party", accessor: "consignor_id" },
    { header: "Branch Name", accessor: "branch" },
    { header: "Invoice Amount", accessor: "invoice_amount" },
    { header: "Balance", accessor: "balance" },
    { header: "Due Date", accessor: "due_date" },
    { header: "Actions", accessor: "action" },
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">

            {childsUser?.view === 1 && <Link to={item?.billraise_type === 3 ? `details/${item?._id}/${item?.billraise_type}` : `details/${item?._id}`}
              className='_avPointer'
              style={{ textDecoration: 'none' }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </Link>}

            {/* {childsUser?.view === 1 && <div
              // onClick={(e) => editHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>}

            {childsUser?.view === 1 && <div
              // onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>} */}
          </div>
        </div>
      </>,
      consignor_id: <>{item?.consignor_id?.name ? item?.consignor_id?.name : '-'}</>,
      type: <>{item?.billraise_type ? constant?.billRaiseType[item?.billraise_type] : '-'}</>,
      invoice_number: <Link to={item?.billraise_type === 3 ? `details/${item?._id}/${item?.billraise_type}` : `details/${item?._id}`}>{item?.invoice_number ? item?.invoice_number : '-'}</Link>,
      invoice_amount: <> {item?.invoice_summary?.invoice_amount ? <> &#x20B9; {item?.invoice_summary?.invoice_amount?.toFixed(2)} </> : '-'} </>,
      balance: <> {item?.invoice_summary?.balance ? <> &#x20B9; {item?.invoice_summary?.balance?.toFixed(2)} </> : '-'} </>,
      date: <>{item?.createdAt ? utils.formateDateCalander(item?.createdAt) : '-'}</>,
      due_date: <>{item?.due_date ? utils.formateDateCalander(item?.due_date) : '-'}</>,
      branch: <> {item?.branch_id?.branch ? item?.branch_id?.branch : '-'} </>,
      action: (
        <>
          {item?.invoice_status ? masterData.invoice_status[item?.invoice_status] : '-'}
        </>
      ),
    }));
  };
  // invoice list end

  // pending lr list start
  const pedingLrcolumns = [
    { header: "Trip Number", accessor: "trip_number" },
    { header: "LR Number", accessor: "lr_number" },
    { header: "LR Date", accessor: "lr_date" },
    { header: "Party", accessor: "party" },
    { header: "Amount", accessor: "amount" },
    { header: "Balance Freight", accessor: "balance_freight" },
    { header: "LR Status", accessor: "lr_status" },
    { header: "POD Status", accessor: "pod_status" },
    { header: "Location", accessor: "location" },
    { header: "Invoice Number", accessor: "invoice_number" },
    { header: "Branch", accessor: "branch" },
  ];

  const rowListDataPendingLr = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">

            {childsUser?.view === 1 && <Link to={item?.billraise_type === 3 ? `details/${item?._id}/${item?.billraise_type}` : `details/${item?._id}`}
              className='_avPointer'
              style={{ textDecoration: 'none' }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </Link>}

            {childsUser?.view === 1 && <div
              // onClick={(e) => editHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>}

            {childsUser?.view === 1 && <div
              // onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>}
          </div>
        </div>
      </>,
      trip_number: <div className='color_data _avPointer' onClick={(e) => navigate(`/trip/addtrip/dispatched/${item?.trip_id?._id}`)}>{item?.trip_id?.trip_number ? item?.trip_id?.trip_number : '-'}</div>,
      lr_number: <div className='color_data _avPointer' onClick={(e) => handleDetailsAction(item)}>{item?.lr_number ? item?.lr_number : '-'}</div>,
      lr_date: <>{item?.invoice_date ? utils.customizeDate(item?.invoice_date) : '-'}</>,
      party: <>{item?.consignor_id?.name ? item?.consignor_id?.name : '-'}</>,
      amount: <> &#x20B9; {item?.lr_freight?.total_freight ? item?.lr_freight?.total_freight?.toFixed(2) : 0}</>,
      balance_freight: <> &#x20B9; {item?.lr_freight?.balance_freight ? item?.lr_freight?.balance_freight?.toFixed(2) : 0}</>,
      lr_status: item?.lr_status ? (
        <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span>
      ) : '-',
      pod_status: item?.pod_status ? <span className={masterData?.pod_status[item?.pod_status] === 'Pending' ? '_lrPending_status' : (masterData?.pod_status[item?.pod_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.pod_status[item?.pod_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.pod_status[item?.pod_status] === 'Received' ? '_lrDelivered_status' : (masterData?.pod_status[item?.pod_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.pod_status[item?.pod_status] ? masterData?.pod_status[item?.pod_status] : ''} </span>
        : '-',
      location: <>{item?.from_location ? `${item?.from_location ? item?.from_location : ''} - ${item?.to_location ? item?.to_location : '-'}` : '-'}</>,
      // invoice_number: <Link to={item?.billraise_type === 3 ? `details/${item?._id}/${item?.billraise_type}` : `details/${item?._id}`}>{item?.invoice_number ? item?.invoice_number : '-'}</Link>,
      invoice_number: <>{item?.invoice_number ? item?.invoice_number : '-'}</>,
      branch: <> {item?.branch_id?.branch ? item?.branch_id?.branch : '-'} </>,
    }));
  };
  // pending lr list end

  // claim list start
  const claimcolumns = [
    { header: "Trip Number", accessor: "trip_number" },
    { header: "LR Number", accessor: "lr_number" },
    { header: "LR Date", accessor: "lr_date" },
    { header: "Party", accessor: "party" },
    { header: "Branch", accessor: "branch" },
    { header: "Claim Type", accessor: "claim_type" },
    { header: "Category", accessor: "category_type" },
    { header: "Amount", accessor: "amount" },
    { header: "Balance Freight", accessor: "balance_freight" },
    { header: "Invoice Status", accessor: "invoice_status" },
  ];

  const rowListDataClaim = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">

            {childsUser?.view === 1 && <Link to={item?.billraise_type === 3 ? `details/${item?._id}/${item?.billraise_type}` : `details/${item?._id}`}
              className='_avPointer'
              style={{ textDecoration: 'none' }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </Link>}

            {childsUser?.view === 1 && <div
              // onClick={(e) => editHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>}

            {childsUser?.view === 1 && <div
              // onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>}
          </div>
        </div>
      </>,
      trip_number: <div className='color_data _avPointer' onClick={(e) => navigate(`/trip/addtrip/dispatched/${item?.trip?._id}`)}>{item?.trip?.trip_number ? item?.trip?.trip_number : '-'}</div>,
      lr_number: <div className='color_data _avPointer' onClick={(e) => handleDetailsAction(item?.lr)}>{item?.lr?.lr_number ? item?.lr?.lr_number : '-'}</div>,
      lr_date: <>{item?.lr?.invoice_date ? utils.customizeDate(item?.lr?.invoice_date) : '-'}</>,
      party: <>{item?.vendor_detail?.name ? item?.vendor_detail?.name : '-'}</>,
      branch: <> {item?.branch?.branch ? item?.branch?.branch : '-'} </>,
      claim_type: <> {item?.voucher_no ? item?.voucher_no : '-'} | {item?.sub_type_name ? item?.sub_type_name : item?.type_name} </>,
      category_type: <> {item?.category_type === 1 ? item?.categories[0]?.category?.name : (item?.category_type === 2 ? item?.category_name : '')} </>,
      amount: <> &#x20B9; {item?.total_amount ? item?.total_amount?.toFixed(2) : 0}</>,
      balance_freight: <> &#x20B9; {item?.lr?.lr_freight?.balance ? item?.lr?.lr_freight?.balance?.toFixed(2) : 0}</>,
      invoice_status: <>{item?.billraise_status === 0 ? 'Pending' : '-'}</>,
    }));
  };
  // claim list end

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const handleCreateBillRaise = (event) => {
    event.preventDefault();
    navigate('createbillraise')
    setInvoiceBillRaiseData({});
  }

  const handleCallBckValue = (data) => {
    setFilter((s) => ({ ...s, status: data, search: '', offset: 1 }))
    setInvoiceList([]);
    setPendingLrList([]);
    setClaimList([]);
  }

  const tabProps = {
    tabList: constant.billRaiseTabs,
    callBackTab: handleCallBckValue,
    activeTab: filter?.status,
    invoiceBillRaiseClass: "toggle_bill_invc",
  }

  const invoiceFiltsProps = {
    tabList: constant.topBillRaiseTabs,
    callBackTab: handleCallBckValue,
    activeTab: filter?.status,
    invoiceBillRaiseClass: "toggle_bill_invc",
    filter: filter,
    setFilter: (data) => setFilter(data)
  }

  const tabHandler = (id) => {
    setInvoiceActiveTab(id);
    setFilter((s) => ({ ...s, offset: 1 }))
  }

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...pendingFilters, [name]: item };
    setPendingFilters(stateObj);
    setFilter((s) => ({ ...s, offset: 1 }))
  };

  const handleApply = (newRange) => {
    setPendingFilters((s) => ({
      ...s,
      start_date: moment(newRange?.startDate).format("YYYY-MM-DD"),
      end_date: moment(newRange?.endDate).format("YYYY-MM-DD"),
    }));
  };

  useEffect(() => {
    if (masterData?.lr_status_list) {
      setMasterDataLrStatus(masterData?.lr_status_list?.filter((el) => el?.id == 3 || el?.id == 4 || el?.id == 5)?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      }))
    }
    if (masterData?.pod_status_list) {
      setMasterDataPodStatus(masterData?.pod_status_list?.map((el) => {
        return {
          label: el?.name,
          value: el?.id,
        };
      }))
    }
  }, [masterData])

  const getDropdownDataConsignorList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: 100,
        offset: 1,
        search: '',
      }
      const res = await getConsignorDropdownListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.consignor_list?.map((el) => {
          return {
            label: el?.name,
            value: el?._id,
          }
        })
        setConsignorList(data)
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    if (filter.status === 2) {
      getDropdownDataConsignorList();
    }
  }, [filter.status])

  const clearFunctionality = (event) => {
    event.preventDefault();
    setPendingFilters((s) => ({
      ...s,
      search: '',
      consignor_id: {},
      pod_status: {},
      lr_status: {},
      start_date: "",
      end_date: "",
    }))
    setFilter((s) => ({ ...s, offset: 1 }))
  }

  const disableFn = useMemo(() => {
    return !pendingFilters?.search && !pendingFilters?.consignor_id?.value && !pendingFilters?.pod_status?.value && !pendingFilters?.lr_status?.value && !pendingFilters?.start_date && !pendingFilters?.end_date ? true : false
  }, [pendingFilters])

  const handleDetailsAction = (data) => {
    setShowLrDetail(data);
  }

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);
  }

  // useEffect(() => {
  //   setIsMaterialIndex('');
  // }, [showAddLR])

  const callListApifunction = () => {
    if (filter.status === 1) {
      getDataInvoiceBillRaiseList();
    }
    if (filter.status === 2) {
      getDataPendingLrList();
    }
    if (filter.status === 3) {
      getDataClaimList();
    }
  }

  return (
    <>
      <div className='__invoicing_pageNw'>
        <TabWithFillter {...invoiceFiltsProps} billClick={(e) => handleCreateBillRaise(e)} dynamicClass='__invoiceTopFilters' />

        {filter.status === 1 &&
          <>
            <div className='__invoicInnerStat_tabs'>
              <ul className="nav nav-tabs" id="myTabNx" role="tablist">
                {
                  invoiceCounts?.map((el, ind) => {
                    return (
                      <li className="nav-item" role="presentation" key={ind + el?.name}>
                        <button
                          className={`nav-link ${(invoiceActiveTab === el?.id) ? 'active' : ''}`}
                          type="button"
                          aria-selected={(invoiceActiveTab === el?.id)}
                          onClick={(e) => tabHandler(el?.id)}
                        // disabled={disabled}
                        >
                          <div className='__invoicInnerStat_flex'>
                            <div className='__invFlex_grow'>
                              <h6 style={{ marginBottom: '8px', textTransform: 'uppercase' }}>{el?.name}</h6>
                              <h2>{el?.count}</h2>
                              <h6>{el?.amount_key} {el?.invoice_amount?.toFixed(2)}</h6>
                            </div>
                            <div className={`__invTb_icon ${el?.value}`}>
                              <img src={el?.src} alt="All Invoice" />
                            </div>
                          </div>
                        </button>
                      </li>
                    )
                  })
                }
              </ul>
            </div>

            {loading ?
              <div className='_tabWith_invoiceTab' style={{ justifyContent: 'center' }}>
                <div key="loader">
                  <div colSpan={columns?.length} style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                </div>
              </div>
              :
              <div className='_tabWith_invoiceTab'>
                <BootstrapTable
                  tableClass="__invoiceTble"
                  columns={columns}
                  data={rowListData(invoiceList?.length > 0 ? invoiceList : [])}
                  // isLoading={loading}
                />
                {invoiceList?.length > 0 &&
                  <div className='paginationFt_avt '>
                    <CustomPagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      currentPage={filter.offset}
                      onPageChange={handlePageChange}
                    />
                  </div>}
              </div>
            }
          </>
        }

        {filter.status === 2 &&
          <>
            <div className='__totalLR_pendingInvc_main'>
              <div className='__totalLR_pendingInvc'>
                <h4>Total LR Pending for Invoicing</h4>
                <div className='__totalLR_pendingInvc_flex'>
                  <h2>₹ {pendingLrCounts?.total_freight?.toFixed(2)}</h2>
                  <p>across {totalItems} invoices</p>
                </div>
              </div>

              <div className='__filtsTb_flexMain'>
                <h4 style={{ marginBottom: '10px' }}>Filters </h4>

                <div className='__filtsTb_flex'>
                  <div className='__fltsInx_bx'>
                    <CommonDateRange
                      key={`${pendingFilters.start_date}-${pendingFilters.end_date}`}
                      initialStartDate={
                        pendingFilters.startDate
                          ? pendingFilters.startDate
                          : ""
                      }
                      initialEndDate={
                        pendingFilters.endDate
                          ? pendingFilters.endDate
                          : ""
                      }
                      datePrefield={
                        !pendingFilters.start_date &&
                          !pendingFilters.end_date
                          ? false
                          : true
                      }
                      onApply={handleApply}
                    />
                  </div>

                  <div className='__fltsInx_bx'>
                    <CustomSelect
                      options={masterDataPodStatus}
                      label="POD Status"
                      placeholder="Select POD Status"
                      name="pod_status"
                      value={pendingFilters?.pod_status}
                      onSelect={(data) => onhandleSelect(data, 'pod_status')}
                    />
                  </div>

                  <div className='__fltsInx_bx'>
                    <CustomSelect
                      label='Party'
                      placeholder="Select Party"
                      options={consignorList}
                      value={pendingFilters?.consignor_id}
                      onSelect={(data) => onhandleSelect(data, 'consignor_id')}
                    />
                  </div>

                  <div className='__fltsInx_bx'>
                    <CustomSelect
                      options={masterDataLrStatus}
                      label="LR Status"
                      placeholder="Select LR Status"
                      name="lr_status"
                      value={pendingFilters?.lr_status}
                      onSelect={(data) => onhandleSelect(data, 'lr_status')}
                    />
                  </div>

                  <div className='__fltsInx_bx'>
                    <div className="_inpW_search  ">
                      <svg
                        className="srcIcon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          opacity="0.2"
                          d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                          fill="black"
                        ></path>
                      </svg>
                      <input
                        type="text"
                        placeholder="Search"
                        className="simpleFilter_input"
                        autoComplete="off"
                        value={pendingFilters?.search}
                        onChange={(e) => setPendingFilters((s) => ({ ...s, search: e.target.value }))}
                      />
                      {pendingFilters?.search ? (
                        <span
                          className="clear-icon"
                          onClick={(e) => setPendingFilters((s) => ({ ...s, search: '' }))}
                        >
                          <RxCross2 size={20} color="black" />
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div style={{ marginLeft: 'auto', display: 'flex' }}>
                    <button className={disableFn ? '__filtsIcon' : '__filtsIcon2'} onClick={(e) => clearFunctionality(e)} disabled={disableFn}><FaFilter /></button>
                  </div>
                </div>
              </div>

            </div>

            {loading ?
              <div className='_tabWith_invoiceTab' style={{ justifyContent: 'center' }}>
                <div key="loader">
                  <div colSpan={columns?.length} style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                </div>
              </div>
              :
              <div className='_tabWith_invoiceTab'>
                <BootstrapTable
                  tableClass="__invoiceTble"
                  columns={pedingLrcolumns}
                  data={rowListDataPendingLr(pendingLrList?.length > 0 ? pendingLrList : [])}
                />
                {pendingLrList?.length > 0 ?
                  <div className='paginationFt_avt '>
                    <CustomPagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      currentPage={filter.offset}
                      onPageChange={handlePageChange}
                    />
                  </div> : <></>}
              </div>
            }
          </>
        }

        {filter.status === 3 &&
          <>
            <div className='__totalLR_pendingInvc_main'>
              <div className='__totalLR_pendingInvc'>
                <h4>Total Claim Value</h4>
                <div className='__totalLR_pendingInvc_flex'>
                  <h2>₹ {claimCounts?.total_amount ? claimCounts?.total_amount?.toFixed(2) : 0}</h2>
                  <p>across {totalItems} invoices</p>
                </div>
              </div>
            </div>
            {loading ?
              <div className='_tabWith_invoiceTab' style={{ justifyContent: 'center' }}>
                <div key="loader">
                  <div colSpan={columns?.length} style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                </div>
              </div>
              :
              <div className='_tabWith_invoiceTab'>
                <BootstrapTable
                  tableClass="__invoiceTble"
                  columns={claimcolumns}
                  data={rowListDataClaim(claimList?.length > 0 ? claimList : [])}
                  // isLoading={loading}
                />
                {claimList?.length > 0 ?
                  <div className='paginationFt_avt '>
                    <CustomPagination
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      currentPage={filter.offset}
                      onPageChange={handlePageChange}
                    />
                  </div> : <></>}
              </div>
            }
          </>
        }

        {filter.status === 4 &&
          <div className="__supplimentry_main">
            <div>
              <div class="__supplimentry_card">
                <div className='__iconMainBx'><div class="icon-box"><AiOutlineTool /> <img className='__sprkleImg' src={sparkelIcon} alt="" /></div></div>
                <div class="__supBadge"><FiClock /> Coming Soon</div>
                <h2>Supplementary Bills Feature</h2>
                <p>We're crafting something amazing! Our supplementary billing feature will revolutionize how you manage additional charges and amendments.</p>

                <div class="features">
                  <div class="feature-box __featureGreen"><img src={smrtCacl} alt="" /> <span>Smart Calculations</span></div>
                  <div class="feature-box __featureBlue"><img src={quckpross} alt="" /> <span>Quick Processing</span></div>
                  <div class="feature-box __featurePink"><img src={detailAnl} alt="" /> <span>Detailed Analytics</span></div>
                </div>

                <div class="notify-text" style={{ marginBottom: '12px' }}>Want to be notified when it’s ready?</div>
                <button class="_invisibleBtn">Contact us</button>

              </div>
              <div class="footer-text">
                In the meantime, explore our other powerful billing features above
              </div>
            </div>
          </div>
        }

        {/* <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="allInvoice-tab-pane" role="tabpanel" aria-labelledby="allInvoice-tab" tabindex="0">...</div>
          <div class="tab-pane fade" id="pending-tab-pane" role="tabpanel" aria-labelledby="pending-tab" tabindex="0">...</div>
          <div class="tab-pane fade" id="overdue-tab-pane" role="tabpanel" aria-labelledby="overdue-tab" tabindex="0">...</div>
        </div> */}



        {/* <ButtonHeading
        title={"Bill Raise"}
        onClick={(e) => handleCreateBillRaise(e)}
        buttonTitle={childsUser?.create === 1 && "Raise Bill"}
        showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        isDebouncedSearch={false}
        filter={filter}
        setFilter={setFilter}
      /> */}

        {/* <div className='__invOice_main'> */}
        {/* <div className='addPr_flBx'>
          <Tab {...tabProps} />
        </div> */}

      </div >

      {/* </div> */}

      < div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`
        }
        tabIndex={- 1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div >
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

      {
        isDelete?.company_id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showAddLR ? 'visible' : 'hidden' }}
      >
        {showAddLR
          && (
            <AddEditLrModal isOpen={showAddLR} onClose={() => setShowAddLR(false)} callGetData={(e) => callListApifunction(e)} />
          )
        }
      </div>
      <div className={showAddLR ? 'offBack_drop' : ''}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
      >
        {showLrDetail
          && (
            <LrDetailModal
              isOpen={showLrDetail}
              onClose={(e) => setShowLrDetail(false)}
              nextModal={(e) => handleNextModal(e)}
            />
          )
        }
      </div>
      <div className={showLrDetail ? 'offBack_drop' : ''}></div>
    </>
  )
}

export default Invoicing